import {
  FilterFieldDataType,
  FilterFieldEditorType,
} from '@warebee/shared/common';
import { ActualityHqDataColumn } from '@warebee/shared/dataset-queries';
import { TFunction } from 'i18next';
import { FilterFieldConfig } from '../../common/types';
import i18n from '../../i18n';

export function getActualityHqConfigBase(
  t: TFunction<'app'> = i18n.t,
): FilterFieldConfig<ActualityHqDataColumn>[] {
  return [
    {
      type: 'eventId',
      title: t('Event Id', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      disabled: true,
      group: t('Events', { ns: 'dataset' }),
    },
    {
      type: 'eventProcessType',
      title: t('Process Type', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Events', { ns: 'dataset' }),
    },
    {
      type: 'eventType',
      title: t('Event Type', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Events', { ns: 'dataset' }),
    },
    {
      type: 'consignee',
      title: t('Consignee', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Item', { ns: 'dataset' }),
    },
    {
      type: 'sku',
      title: t('Sku', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Item', { ns: 'dataset' }),
    },
    {
      type: 'uom',
      title: t('Uom', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Item', { ns: 'dataset' }),
    },
    {
      type: 'quantity',
      title: t('Quantity', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.NumberRange,
      group: t('Item', { ns: 'dataset' }),
    },
    {
      type: 'scanCode',
      title: t('Scan Code', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Item', { ns: 'dataset' }),
    },
    {
      type: 'warehouseAreaSource',
      title: t('Warehouse Area Source', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      disabled: true,
      group: t('Layout', { ns: 'dataset' }),
    },
    {
      type: 'locationIdSource',
      title: t('Location Id Source', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      disabled: true,
      group: t('Layout', { ns: 'dataset' }),
    },

    {
      type: 'agentType',
      title: t('Agent Type', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Resources', { ns: 'dataset' }),
    },
    {
      type: 'agentId',
      title: t('Agent Id', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Resources', { ns: 'dataset' }),
    },
    {
      type: 'agentUser',
      title: t('Agent User', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Resources', { ns: 'dataset' }),
    },
    {
      type: 'agentEnergy',
      title: t('Agent Energy', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      disabled: true,
      group: t('Resources', { ns: 'dataset' }),
    },
    {
      type: 'agentSignalStrength',
      title: t('Agent Signal Strength', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      disabled: true,
    },
    {
      type: 'eventStartTime',
      title: t('Event Start Time', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      disabled: true,
    },
    {
      type: 'jobId',
      title: t('Job Id', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    {
      type: 'jobLine',
      title: t('Job Line', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    {
      type: 'jobGroupId',
      title: t('Job Group Id', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    // {
    //   type: 'datasetObjectId',
    //   title: t('Dataset Object Id', { ns: 'dataset' }),
    //   editorType: FilterFieldEditorType.MultipleCheck,
    //   disabled: true,
    // },
    {
      type: 'eventEndTime',
      title: t('Event End Time', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    // {
    //   type: 'importJobId',
    //   title: t('Import Job Id', { ns: 'dataset' }),
    //   editorType: FilterFieldEditorType.MultipleCheck,
    //   disabled: true,
    // },
    {
      type: 'skuKey',
      title: t('Sku Key', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      disabled: true,
    },
    {
      type: 'jobKey',
      title: t('Job Key', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      disabled: true,
    },
    {
      type: 'pickByAssignment',
      title: t('Pick By Assignment', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Demand', { ns: 'dataset' }),
    },
    {
      type: 'skuGroup',
      title: t('Sku Group', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Item', { ns: 'dataset' }),
    },
    // {
    //   type: 'name',
    //   title: t('Name', { ns: 'dataset' }),
    //   editorType: FilterFieldEditorType.MultipleCheck,
    // },
    // {
    //   type: 'description',
    //   title: t('Description', { ns: 'dataset' }),
    //   editorType: FilterFieldEditorType.MultipleCheck,
    // },
    {
      type: 'subGroup',
      title: t('Sub Group', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Item', { ns: 'dataset' }),
    },
    {
      type: 'transportClass',
      title: t('Transport Class', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Item', { ns: 'dataset' }),
    },
    {
      type: 'stockCategory',
      title: t('Stock Category', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Item', { ns: 'dataset' }),
    },
    {
      type: 'storageClass',
      title: t('Storage Class', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Item', { ns: 'dataset' }),
    },
    {
      type: 'pollutionClass',
      title: t('Pollution Class', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Item', { ns: 'dataset' }),
    },
    {
      type: 'lowerUom',
      title: t('Lower Uom', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Item', { ns: 'dataset' }),
    },
    {
      type: 'netWeight',
      title: t('Weight', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.NumberRange,
      group: t('Item', { ns: 'dataset' }),
    },
    {
      type: 'length',
      title: t('Length', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.NumberRange,
      group: t('Item', { ns: 'dataset' }),
    },
    {
      type: 'width',
      title: t('Width', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.NumberRange,
      group: t('Item', { ns: 'dataset' }),
    },
    {
      type: 'height',
      title: t('Height', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.NumberRange,
      group: t('Item', { ns: 'dataset' }),
    },
    {
      type: 'volume',
      title: t('Volume (Cube)', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.NumberRange,
      group: t('Item', { ns: 'dataset' }),
    },
    {
      type: 'unitsPerLowestUom',
      title: t('Units Per Lowest Uom', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Item', { ns: 'dataset' }),
    },
    {
      type: 'ean',
      title: t('EAN', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Item', { ns: 'dataset' }),
    },
    {
      type: 'upc',
      title: t('UPC', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Item', { ns: 'dataset' }),
    },
    {
      type: 'warehouseArea',
      title: t('Warehouse Area', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      disabled: true,
      group: t('Layout', { ns: 'dataset' }),
    },
    {
      type: 'locationId',
      title: t('Location Id', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Layout', { ns: 'dataset' }),
    },
    // {
    //   type: 'layoutLocationId',
    //   title: t('Layout Location Id', { ns: 'dataset' }),
    //   editorType: FilterFieldEditorType.MultipleCheck,
    // },
    {
      type: 'locationOrder',
      title: t('Location Order', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Layout', { ns: 'dataset' }),
    },
    {
      type: 'locationStatus',
      title: t('Location Status', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Layout', { ns: 'dataset' }),
    },
    {
      type: 'locationLevel',
      title: t('Level', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Layout', { ns: 'dataset' }),
    },
    // {
    //   type: 'locationLength',
    //   title: t('Length', { ns: 'dataset' }),
    //   editorType: FilterFieldEditorType.MultipleCheck,
    // },
    // {
    //   type: 'locationWidth',
    //   title: t('Width', { ns: 'dataset' }),
    //   editorType: FilterFieldEditorType.MultipleCheck,
    // },
    // {
    //   type: 'locationHeight',
    //   title: t('Height', { ns: 'dataset' }),
    //   editorType: FilterFieldEditorType.MultipleCheck,
    // },
    {
      type: 'locationWeight',
      title: t('Weight', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Layout', { ns: 'dataset' }),
    },
    {
      type: 'locationBayId',
      title: t('Bay Id', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Layout', { ns: 'dataset' }),
    },
    // {
    //   type: 'locationBayTitle',
    //   title: t('Location Bay Title', { ns: 'dataset' }),
    //   editorType: FilterFieldEditorType.MultipleCheck,
    // },
    {
      type: 'locationBayPosition',
      title: t('Location Bay Position', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Layout', { ns: 'dataset' }),
    },
    {
      type: 'locationDepthPosition',
      title: t('Location Depth Position', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Layout', { ns: 'dataset' }),
    },
    {
      type: 'locationUsageType',
      title: t('Usage Type', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Layout', { ns: 'dataset' }),
    },
    {
      type: 'locmhtype',
      title: t('MHE Type', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Layout', { ns: 'dataset' }),
    },
    {
      type: 'locationRackingType',
      title: t('Racking Type', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Layout', { ns: 'dataset' }),
    },
    {
      type: 'layoutWarehouseArea',
      title: t('Area', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Layout', { ns: 'dataset' }),
    },
    {
      type: 'locationSide',
      title: t('Side', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Layout', { ns: 'dataset' }),
    },
    {
      type: 'congestionZone',
      title: t('Work Zone', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Layout', { ns: 'dataset' }),
    },
    {
      type: 'locationBayProjection',
      title: t('Location Bay Projection', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Layout', { ns: 'dataset' }),
    },
    {
      type: 'locationHeightFromFloor',
      title: t('Location Height From Floor', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Layout', { ns: 'dataset' }),
    },
    {
      type: 'locationDepthFromFront',
      title: t('Location Depth From Front', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Layout', { ns: 'dataset' }),
    },
    {
      type: 'locationIndexFromFront',
      title: t('Location Index From Front', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Layout', { ns: 'dataset' }),
    },
    {
      type: 'bayType',
      title: t('Bay Type', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Layout', { ns: 'dataset' }),
    },
    // {
    //   type: 'aisleId',
    //   title: t('Aisle Id', { ns: 'dataset' }),
    //   editorType: FilterFieldEditorType.MultipleCheck,
    // },
    {
      type: 'aisleTitle',
      title: t('Aisle', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Layout', { ns: 'dataset' }),
    },
    // {
    //   type: 'planeId',
    //   title: t('Plane Id', { ns: 'dataset' }),
    //   editorType: FilterFieldEditorType.MultipleCheck,
    // },
    {
      type: 'planeTitle',
      title: t('Floor', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Layout', { ns: 'dataset' }),
    },
    // {
    //   type: 'assignmentItem',
    //   title: t('Assignment Item', { ns: 'dataset' }),
    //   editorType: FilterFieldEditorType.MultipleCheck,
    // },
    // {
    //   type: 'lastEventTime',
    //   title: t('Last Event Time', { ns: 'dataset' }),
    //   editorType: FilterFieldEditorType.MultipleCheck,
    //   group: t('Events', { ns: 'dataset' }),
    // },
    {
      type: 'orderLineCount',
      title: t('Line Count', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.IntegerRange,
      group: t('Demand', { ns: 'dataset' }),
    },
    {
      type: 'quantityOrdered',
      title: t('Quantity Ordered', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.IntegerRange,
      group: t('Demand', { ns: 'dataset' }),
    },
    {
      type: 'cumulativePercentRank',
      title: t('ABC % Rank', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.ABCRange,
      dataType: FilterFieldDataType.NumberRange,
      group: t('Demand', { ns: 'dataset' }),
    },
    // {
    //   type: 'percentRank',
    //   title: t('ABC %', { ns: 'dataset' }),
    //   editorType: FilterFieldEditorType.SliderRange,
    //   dataType: FilterFieldDataType.NumberRange,
    // },
    {
      type: 'categoryAbc' as any,
      title: t('ABC Category', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      group: t('Demand', { ns: 'dataset' }),
    },
    {
      type: 'totalDaysOrdered',
      title: t(`Total Days Ordered`, { ns: 'dataset' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.IntegerRange,
      group: t('Demand', { ns: 'dataset' }),
    },
    {
      type: 'totalWeeksOrdered',
      title: t(`Total Weeks Ordered`, { ns: 'dataset' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.IntegerRange,
      group: t('Demand', { ns: 'dataset' }),
    },
    {
      type: 'maxDailyLinesCount',
      title: t(`Daily Pick Count (Max.)`, { ns: 'dataset' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.IntegerRange,
      group: t('Demand', { ns: 'dataset' }),
    },
    {
      type: 'minDailyLinesCount',
      title: t(`Daily Pick Count (Min.)`, { ns: 'dataset' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.IntegerRange,
      group: t('Demand', { ns: 'dataset' }),
    },
    {
      type: 'avgDailyLinesCount',
      title: t(`Daily Pick Count (Avg.)`, { ns: 'dataset' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.NumberRange,
      group: t('Demand', { ns: 'dataset' }),
    },
    {
      type: 'maxWeeklyLinesCount',
      title: t(`Weekly Count (Max.)`, { ns: 'dataset' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.IntegerRange,
      group: t('Demand', { ns: 'dataset' }),
    },
    {
      type: 'minWeeklyLinesCount',
      title: t(`Weekly Count (Min.)`, { ns: 'dataset' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.IntegerRange,
      group: t('Demand', { ns: 'dataset' }),
    },
    {
      type: 'avgWeeklyLinesCount',
      title: t(`Weekly Count (Avg.)`, { ns: 'dataset' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.NumberRange,
      group: t('Demand', { ns: 'dataset' }),
    },
    {
      type: 'eventHour',
      title: t(`Event Hour`, { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      dataType: FilterFieldDataType.Date,
      group: t('Demand', { ns: 'dataset' }),
    },
    {
      type: 'eventDay',
      title: t(`Event Day`, { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      dataType: FilterFieldDataType.Date,
      group: t('Demand', { ns: 'dataset' }),
    },
    {
      type: 'eventWeek',
      title: t(`Event Week`, { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
      dataType: FilterFieldDataType.Date,
      group: t('Demand', { ns: 'dataset' }),
    },
    {
      type: 'idleDurationBetweenJobs',
      title: t('Idle Time', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.NumberRange,
      group: t('Resources', { ns: 'dataset' }),
      // hidden: true,
    },
  ];
}
